export interface ImageRequest {
    caption: string,
    author: string
}

export const emptyImageRequest: ImageRequest = {
    caption: '',
    author: ''
}